export const DEFAULT_STYLE_PRESETS = [
  {
    id: 'commercial_product',
    label: 'สินค้าสมจริงระดับโฆษณา',
    desc: 'แสงสตูดิโอระดับ Hi-End พื้นหลังคลีน ไฮไลต์สินค้าคมชัดระดับ 8K เหมาะสำหรับ Commerce',
    prompt: 'masterpiece commercial studio product photography, clean luxury advertising aesthetic, Hasselblad H6D-100c medium format look, precision key light with softbox fill, crisp subtle rim reflections, pristine minimalist pedestal display, 8k UHD, razor-sharp focus on premium product textures, photorealistic catalog quality, ultra-clean background, studio lighting',
  },
  {
    id: 'comic_line_art',
    label: 'การ์ตูนลายเส้นมินิมอล',
    desc: 'ลายเส้นมินิมอล ตัวละครหัวกลมขาว สไตล์แอนิเมชันเล่าเรื่อง (Stick Figure / Storytime) สีแบน คลีนตา',
    prompt: 'minimalist 2D stick figure animation style, cute storytime webcomic illustration, Casually Explained and TheOdd1sOut aesthetic, simple round smooth bald white head with black outline, minimalist black dot eyes, subtle curved line smile, thin black stick figure limbs, clean solid flat vector colors, zero shading, no gradients, crisp uniform black line art, plain solid off-white background, clean 2D digital vector art',
  },
  {
    id: 'cinematic_realistic',
    label: 'ภาพยนตร์สมจริง',
    desc: 'แสงธรรมชาติ มุมกล้องภาพยนตร์ โทนสี 35mm สไตล์ภาพเล่าเรื่อง',
    prompt: 'cinematic motion picture film still, shot on 35mm Arri Alexa LF cinema lens, shallow depth of field f/1.8, atmospheric volumetric lighting, Panavision anamorphic bokeh, professional color grading with rich shadows and warm highlights, subtle organic 35mm film grain, hyper-photorealistic masterpiece, 8k',
  },
  {
    id: 'ai_rage_dramatic',
    label: 'ดุดันเร้าอารมณ์',
    desc: 'อารมณ์ดุดัน แสงเงาเร้าอารมณ์ คอนทราสต์จัดจ้าน เหมาะกับคลิปปลุกใจ',
    prompt: 'intense dramatic cinematic composition, extreme high-contrast chiaroscuro shadows, powerful volumetric rim lighting, glowing fiery embers and atmospheric smoke, raw visceral emotion, epic dynamic camera angle, hyper-detailed gritty textures, dark moody cyberpunk edge, striking visual storytelling',
  },
  {
    id: '3d_animation',
    label: 'แอนิเมชัน 3D',
    desc: 'คาแรคเตอร์ 3D น่ารัก นุ่มนวล มีชีวิตชีวา สดใสเป็นมิตร',
    prompt: 'charming 3D feature animation render style, Pixar and Disney aesthetic, expressive character and prop design, tactile soft clay subsurface scattering (SSS) lighting, warm golden global illumination, smooth rounded forms, vibrant whimsical color palette, Octane 3D render, 4k ultra-detailed playful atmosphere',
  },
  {
    id: 'tech_cyberpunk',
    label: 'ไซเบอร์พังก์ล้ำสมัย',
    desc: 'แสงนีออน เรโทรฟิวเจอร์ ล้ำสมัย เหมาะกับข่าวเทคและนวัตกรรม',
    prompt: 'futuristic neo-cyberpunk aesthetic, vibrant neon cyan and electric magenta glow, luminous holographic HUD interfaces, sleek metallic and carbon fiber textures, rain-slicked reflective surfaces, dark misty dystopian sci-fi atmosphere, Blade Runner cinematic framing, 8k hyper-detailed',
  },
  {
    id: 'minimalist_aesthetic',
    label: 'มินิมอลโมเดิร์น',
    desc: 'โทนสีสบายตา สไตล์นิตยสาร Kinfolk แสงธรรมชาติ นุ่มนวล คลีนตา',
    prompt: 'modern Scandinavian minimalist photography, soft diffused natural window daylight, muted neutral earth tones, airy negative space, clean geometric lines, elegant architectural simplicity, Kinfolk editorial aesthetic, 8k crisp quiet luxury',
  },
  {
    id: 'vintage_retro',
    label: 'วินเทจฟิล์มคลาสสิก',
    desc: 'โทนฟิล์มยุค 90s อบอุ่น มีเกรนฟิล์มคลาสสิก อารมณ์ย้อนยุค',
    prompt: 'nostalgic 1990s 35mm vintage film photograph, authentic Kodak Portra 400 warm color palette, soft natural halation and lens flare, subtle film dust and organic grain, timeless retro aesthetic, candid cinematic snapshot',
  },
  {
    id: 'custom',
    label: 'กำหนดเอง',
    desc: 'กำหนด Prompt และสไตล์ภาพเองอย่างอิสระ',
    prompt: '',
  },
];

export interface ContentFlowItem {
  id: string;
  category: 'content' | 'commerce';
  label: string;
  badge: string;
  desc: string;
  recommendedStyle: string;
  defaultAudience: string;
  defaultObjective: string;
  defaultCta: string;
}

export const DEFAULT_CONTENT_FLOWS: ContentFlowItem[] = [
  // Content Category
  {
    id: 'explainer',
    category: 'content',
    label: 'สาระความรู้ สรุปย่อ',
    badge: 'สาระ How-To',
    desc: 'อธิบายเรื่องยากให้เข้าใจง่าย สรุปประเด็นเป็นข้อๆ สื่อสารชัดเจน',
    recommendedStyle: 'comic_line_art',
    defaultAudience: 'คนทั่วไปที่อยากเรียนรู้สิ่งใหม่',
    defaultObjective: 'ให้ความรู้และสร้างความเข้าใจง่ายๆ ในเวลาสั้น',
    defaultCta: 'กดติดตามและบันทึกเก็บไว้ดูซ้ำได้เลย',
  },
  {
    id: 'storytelling',
    category: 'content',
    label: 'เรื่องเล่าและดราม่า',
    badge: 'เรื่องเล่า ละคร',
    desc: 'เปิดเรื่องด้วยปม พัฒนาการตัวละคร จุดพลิกผัน ดึงอารมณ์ร่วมลึกซึ้ง',
    recommendedStyle: 'cinematic_realistic',
    defaultAudience: 'ผู้ติดตามที่ชอบเสพเรื่องราวและมุมมองชีวิต',
    defaultObjective: 'สร้างอารมณ์ร่วมและการมีส่วนร่วมสูง',
    defaultCta: 'คอมเมนต์บอกความรู้สึกหรือมุมมองของคุณใต้คลิปนี้',
  },
  {
    id: 'news_trend',
    category: 'content',
    label: 'เกาะกระแสและข่าว',
    badge: 'เกาะกระแส ข่าว',
    desc: 'ประเด็นร้อนรอบโลก สรุปข้อมูลสดใหม่ ฉับไว กระชับ ไม่ตกเทรนด์',
    recommendedStyle: 'tech_cyberpunk',
    defaultAudience: 'สายอัปเดตข่าวสาร เทคโนโลยี และเทรนด์ใหม่',
    defaultObjective: 'อัปเดตเทรนด์ด่วนและสรุปประเด็นสำคัญในทันที',
    defaultCta: 'กดติดตามช่องไว้ จะได้ไม่พลาดสรุปเทรนด์เด็ดทุกวัน',
  },
  {
    id: 'motivation',
    category: 'content',
    label: 'ปลุกใจและข้อคิด',
    badge: 'แรงบันดาลใจ',
    desc: 'คำคมพลังบวก ปลุกไฟในการทำงาน เอาชนะอุปสรรคและพัฒนาตนเอง',
    recommendedStyle: 'ai_rage_dramatic',
    defaultAudience: 'คนวัยทำงานและผู้ที่กำลังมองหาพลังใจ',
    defaultObjective: 'ปลุกพลังใจและสร้างแรงผลักดันเชิงบวก',
    defaultCta: 'แชร์คลิปนี้ส่งต่อพลังบวกให้เพื่อนที่คุณห่วงใย',
  },
  // Commerce Category
  {
    id: 'commercial_promo',
    category: 'commerce',
    label: 'สปอตโฆษณาและป้ายยา',
    badge: 'ยิงแอด ป้ายยา',
    desc: 'Hook 3 วินาทีแรก ชูจุดขายเด่น โปรโมชันพิเศษ กระตุ้นความอยากซื้อ',
    recommendedStyle: 'commercial_product',
    defaultAudience: 'นักช้อปออนไลน์ที่มองหาโปรโมชันและความคุ้มค่า',
    defaultObjective: 'กระตุ้นยอดขายและปิดการขายทันที',
    defaultCta: 'คลิกลิงก์สั่งซื้อที่ตะกร้าด้านล่างด่วน ก่อนหมดโปรโมชัน',
  },
  {
    id: 'product_review',
    category: 'commerce',
    label: 'รีวิวสินค้าจริง',
    badge: 'รีวิว แกะกล่อง',
    desc: 'เจาะลึกฟังก์ชัน สเปก การใช้งานจริง และการเปรียบเทียบความคุ้มค่า',
    recommendedStyle: 'commercial_product',
    defaultAudience: 'ผู้บริโภคที่กำลังหาข้อมูลและตัดสินใจซื้อสินค้า',
    defaultObjective: 'สร้างความมั่นใจในคุณภาพและการใช้งานจริงของสินค้า',
    defaultCta: 'สนใจดูรายละเอียดเพิ่มเติมได้ที่ตะกร้าหรือหน้าโปรไฟล์',
  },
  {
    id: 'problem_solver',
    category: 'commerce',
    label: 'แก้ไขปัญหาเฉพาะจุด',
    badge: 'ชี้ปัญหาและทางออก',
    desc: 'เปิดด้วยปัญหาที่คนส่วนใหญ่เจอ แล้วนำเสนอสินค้าชิ้นนี้เป็นทางออกที่ตอบโจทย์',
    recommendedStyle: 'commercial_product',
    defaultAudience: 'คนที่มีปัญหาตรงกับโจทย์และต้องการวิธีแก้ไขที่ได้ผล',
    defaultObjective: 'โน้มน้าวใจด้วยการแก้ปัญหาที่ตรงจุดและคุ้มค่า',
    defaultCta: 'มีไว้ติดบ้านชีวิตง่ายขึ้นแน่นอน กดสั่งได้ที่ตะกร้าเลย',
  },
];

